export const optionLabel = (code: string, description?: string | null): string =>
  description ? `${code} - ${description}` : code;
